module.exports = __webpack_public_path__ + "static/harvard-72cacbc1b35ea282585407f1acad995f.png";